import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { ConformComponent } from '../../conform/conform.component';
import { PatientService, UserService } from '../../shared';


@Component({
  selector: 'app-uservalidatefor-cc',
  templateUrl: './uservalidatefor-cc.component.html',
  styleUrls: ['./uservalidatefor-cc.component.css']
})
export class UservalidateforCcComponent implements OnInit {


  patid: any;
  public timealert = environment.timelimit;
  showinvaild: boolean = false
  patname: any = {};
  public user: any = {
    dob: '',
  }
  public bobMaxDate = new Date();
  welcome: any;
  modalRef: any;
  resdata: any;
  expires: MatDialogRef<ConformComponent>;
  onbehalfName: any;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    public datepipe: DatePipe,
    private toastr: ToastrService,
    private patientservice: PatientService,
    private userservic: UserService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private dialog: MatDialog,
    private nav: Router
  ) { }

  ngOnInit() {


    this.routerr.params.subscribe(params => {
      this.patid = params
      this.patientservice.changeNav(params['id'])
      this.patid = params['id']
      // ////console.log(this.patid);
    });
    this.patientservice
      .getwelcomepat(this.patid)
      .subscribe(
        data => {
          if (data.status == 'failure') {
            this.expires = this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
            this.expires.componentInstance.message = data.message;
          }
          else {
            this.patname = data.patientName;
            this.onbehalfName = data.onbehalfName
          }
          // ////console.log("name",this.patname)
        }
      );
  }
  saveUser(result) {
    this.userservic.getranidcheck(this.patid)
      .subscribe(
        data => {
          window.localStorage['randId'] = this.patid
          if (data.userInfo.status == "success") {
            this.nav.navigate(['uservalidate']);

          } else if (data.userInfo.status == "failure") {
            this.resdata = "Unauthorized Access";
            this.modalRef = this.modalService.show(result, { class: 'modal-sm', backdrop: "static" });
          }
        })
  }

}